/*
 *  (c) 2015 - 2023 ENISCO by FORCAM GmbH
 */

import React from 'react'
import {ListItemIcon, ListItemText, MenuItem} from '@mui/material'
import {Link} from '@mui/icons-material'
import {FormattedMessage, useIntl} from 'react-intl'
import {useError, useNotification, useParameters, useResolver, useTest} from '@enisco/mcc-react-lib'
import {useNavigate} from 'react-router-dom'
import {Hardlink} from '../../../../model/hardlinks'
import useCurrentApp from '../../../../hooks/useCurrentApp'
import {pathToHardlink} from '../../../../util/navigation'

interface Props {
  onClose: () => void
}

export const HardlinkItem: React.FC<Props> = ({onClose}) => {
  const resolver = useResolver()
  const error = useError()
  const [parameters] = useParameters()
  const [app] = useCurrentApp()
  const navigate = useNavigate()
  const test = useTest()
  const notification = useNotification()
  const intl = useIntl()

  const mockedData = {
    ID: '123456'
  }

  const createHardlink = () => {
    resolver('mcc-portal-api', '/internal/hardlinks', {
      options: {
        method: 'POST',
        headers: {'Content-Type': 'application/json'},
        body: JSON.stringify({
          app: app?.app,
          module: app?.module,
          parameters: parameters
        } as Hardlink)
      },
      mockedResponse: test ? JSON.stringify(mockedData) : undefined
    })
      .then((response: {json: () => any}) => response.json())
      .then((data: {ID: string}) => {
        navigate({
          pathname: pathToHardlink(data.ID)
        })
        notification(
          'success',
          intl.formatMessage({
            id: 'ProfileOptions.HardlinkSuccess',
            defaultMessage: 'Copied to clipboard'
          })
        )
        navigator.clipboard.writeText(window.location.toString()).then(onClose)
      })
      .catch(error)
  }

  return (
    <MenuItem data-testid='HardlinkItem:item' onClick={createHardlink}>
      <ListItemIcon>
        <Link color={'primary'} />
      </ListItemIcon>
      <ListItemText>
        <FormattedMessage
          id='TitleBarMenu.CopyHardlink'
          defaultMessage='Copy hard link'
        />
      </ListItemText>
    </MenuItem>
  )
}
